import { render, staticRenderFns } from "./exerciseComponent.vue?vue&type=template&id=f92390f0&scoped=true&%3Aid=propX&"
import script from "./exerciseComponent.vue?vue&type=script&lang=js&"
export * from "./exerciseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92390f0",
  null
  
)

export default component.exports